import * as core from '../../../../../../../core'

import { query } from './salary-to-bill-rate.query'

export const RESOURCE = {
  payload: {
    alias: 'billability-calculator.bill-rate-to-salary',
    description:
      'Calculates a salary from a bill rate based on the Gross Margin and Fringe',
    name: 'Billability Calculator: Bill Rate to Salary',
    query,
    variables: [
      {
        defaultValue: 0,
        id: 'BillRate',
        name: 'Bill Rate',
        type: core.common.value.types.Intrinsic.Decimal,
      },
      {
        defaultValue: 45,
        id: 'GrossMargin',
        name: 'Gross Margin',
        type: core.common.value.types.Intrinsic.Percent,
      },
      {
        defaultValue: 2080,
        id: 'TotalHours',
        name: 'Total Hours',
        type: core.common.value.types.Intrinsic.Integer,
      },
      {
        defaultValue: 33.5,
        id: 'Fringe',
        name: 'Fringe',
        type: core.common.value.types.Intrinsic.Percent,
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
